import { parseTextAndUrlSegments, replaceURLs } from "./extract";

export function makeActBlueRefcodeTransformer(
  refcode: string
): (templateString: string) => string {
  return (templateString: string) => {
    // If there are other ActBlue domains to watch for we can add them here.
    const ACT_BLUE_DOMAINS = [
      "https://secure.actblue.com",
      "http://secure.actblue.com",
    ];

    return replaceURLs(parseTextAndUrlSegments(templateString), url => {
      if (ACT_BLUE_DOMAINS.some(domain => url.startsWith(domain))) {
        try {
          const urlObj = new URL(url);
          urlObj.searchParams.set("refcode2w", refcode);
          return decodeURI(urlObj.href);
        } catch (_e) {
          return url;
        }
      }

      return url;
    }).join("");
  };
}
